export interface ICmsAdditionalMeta {
    [key: string]: any;
}

export namespace NBlogPostPageType {
    export const typeId = 'blog-post';

    export interface ITypeData {
        tags?: number[];
        author?: string;
        authorImage?: string;
        description?: string;
        authorPhone?: string;
        date?: Date;
        readingTime?: string;
        shortDescription?: string;
        backButtonText?: string;
    }
}
